<template>
    <svg
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        viewBox="0 0 24 24"
        stroke="currentColor"
        :class="twClass"
    >
        <path d="M19 14l-7 7m0 0l-7-7m7 7V3"/>
    </svg>
</template>

<script setup lang="ts">
const {twClass = 'w-6 h-6 text-secondary'} = defineProps<{ twClass?: string }>();
</script>
